import { render, staticRenderFns } from "./dialog-tips.vue?vue&type=template&id=61399e61&scoped=true&"
import script from "./dialog-tips.vue?vue&type=script&lang=js&"
export * from "./dialog-tips.vue?vue&type=script&lang=js&"
import style0 from "./dialog-tips.vue?vue&type=style&index=0&id=61399e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61399e61",
  null
  
)

export default component.exports